export default "__VITE_ASSET__DC0pzpJB__"